<template>
  <div class="chat-bubble" :class="{ 'chat-bubble-right': chatData.direction === 'right' }">
    <div class="chat-box">
      <img class="avator" :src="avatarImg" />
      <div class="chat-box-content">
        <div>{{ chatData.name }}</div>
        <div
          class="chat-message"
          :class="[
            chatData.dataType === dataType.IMAGE
              ? ''
              : chatData.direction === 'right'
              ? 'chat-message-right'
              : 'chat-message-left'
          ]"
        >
          <feedback-type
            v-if="chatData.messageType === messageTypes.AVAILABLE_TYPES"
            :data="chatData.data"
            @selectFeedbackTypes="selectFeedbackTypes"
          ></feedback-type>
          <search-result
            v-else-if="chatData.messageType === messageTypes.SEARCH_RESULT"
            :data="chatData.data"
            @selectFeedback="selectFeedback"
          ></search-result>
          <img v-else-if="chatData.dataType === dataType.IMAGE" :src="chatData.data[0]" />
          <div v-else class="message-text">{{ chatData.data }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MESSAGE_TYPE } from '../const/message-type'
import { DATA_TYPE } from '../const/data-type'
import FeedbackType from './feedback-type'
import SearchResult from './search-result'
import defaultAvatar from '../images/default_user.png'
import feedbackLogo from '../images/feedback_logo.png'

export default {
  name: 'chat-bubble',
  components: {
    FeedbackType,
    SearchResult
  },
  props: {
    chatData: {
      type: Object,
      required: true
    }
  },
  computed: {
    avatarImg() {
      return this.chatData.direction === 'right' ? defaultAvatar : feedbackLogo
    }
  },
  data() {
    return {
      messageTypes: MESSAGE_TYPE,
      dataType: DATA_TYPE
    }
  },
  methods: {
    selectFeedback(event) {
      this.$emit('selectFeedback', event)
    },
    selectFeedbackTypes(type) {
      this.$emit('selectFeedbackTypes', type)
    }
  }
}
</script>
